module.exports = __webpack_public_path__ + "static/media/temp_15.f92b6ac6.jpg";